module.exports = __webpack_public_path__ + "static/img/17_phase_function_Paper_PointsHejduk_Prediction.3f7f42a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/17_phase_function_Paper_PointsHejduk_Prediction.png
// module id = Atox
// module chunks = 0